import React, { useEffect, useState } from 'react';
import { Button } from '@alifd/next';
import styles from './index.module.scss';

// import Global from "../../../utils/global";

const statusTxt = {
  PAST: '已过期',
  DISABLE: '已提交',
  ENABLE: '提交',
};

let time;

const ButtonRender = ({ content, askQuestion, isHistory }) => {
  // 历史记录中的按钮，如果status === DISABLE 为已提交，否则都标记为已过期
  const [status, setStatus] = useState<'PAST' | 'DISABLE' | 'ENABLE'>(
    content.status === 'DISABLE' ? 'DISABLE' : isHistory ? 'PAST' : 'ENABLE',
  ); // PAST: 过期; DISABLE: 已提交;

  useEffect(() => {
    if (content.status !== 'DISABLE') {
      time = setTimeout(() => {
        setStatus('PAST');
      }, 180000);
    }
    return () => {
      clearTimeout(time);
      time = undefined;
    };
  }, [content.status]);

  return (
    <div className={styles.chatQuseListBox} style={{ background: 'unset' }}>
      <Button
        disabled={status !== 'ENABLE'}
        className={styles.jumpMenu}
        // style={{
        //   backgroundColor: status !== 'ENABLE' ? '#F0F2F5' : '#FF6700',
        //   color: status !== 'ENABLE' ? '#C9CDD4' : '#FFFFFF',
        // }}
        onClick={() => {
          askQuestion('确认提交', {
            operateId: content.operateId,
            actionType: content.actionType,
            actionParam: {
              orderNoList: content.param.orderNoList,
            },
          });
          setStatus('DISABLE');
        }}
      >
        {statusTxt[status] ?? '提交'}
      </Button>
    </div>
  );
};

export default ButtonRender;
